export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13911.f30a5d34.jpg";